/**
 * The user id (`sub`) from an access token — UI only (which messages are
 * "mine"); the token is never verified or trusted here, the server does that.
 */
export function userIdFromToken(token: string | null | undefined): number | null {
  if (!token) return null;
  const part = token.split(".")[1];
  if (!part) return null;
  try {
    const json = atob(part.replace(/-/g, "+").replace(/_/g, "/").padEnd(Math.ceil(part.length / 4) * 4, "="));
    const sub: unknown = (JSON.parse(json) as { sub?: unknown }).sub;
    return typeof sub === "number" && Number.isSafeInteger(sub) && sub > 0 ? sub : null;
  } catch {
    return null;
  }
}
